import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import "./JobTile.css";
import { getImageSrc } from "../../utils/cmsAPI";

const JobTile = ({ job, onClick }) => {
  const tileRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = tileRef.current;
    const observerOptions = { threshold: 0.1 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, []);

  // Get logo source - prefer logo field, fall back to image_path
  const getLogoSrc = () => {
    if (job.logo) {
      const src = getImageSrc(job.logo);
      if (src) return src;
    }
    if (job.image_path) {
      const src = getImageSrc(job.image_path);
      if (src) return src;
    }
    return `${process.env.PUBLIC_URL}/images/defaultLogo.jpeg`;
  };

  return (
    <Box
      ref={tileRef}
      className={`job-tile ${isVisible ? "visible" : ""}`}
      onClick={() => onClick(job.id, job)}
    >
      <Card className="tile-content">
        <Box className="job-image-wrapper">
          <img
            src={getLogoSrc()}
            alt={`${job.company} logo`}
            className="job-image"
          />
        </Box>
        <Box className="company-name-wrapper">
          <Typography variant="body4" className="company-name" sx={{ fontWeight: "bold" }}>
            {job.company}
          </Typography>
        </Box>
        <CardContent className="job-details">
          <Typography variant="body4" className="job-title">
            {job.title}
          </Typography>
          {job.domain && (
            <Typography variant="body4" className="domain">
              {job.domain}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default JobTile;